function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.35355 0.646446C4.15829 0.451184 3.84171 0.451184 3.64645 0.646446L0.464466 3.82843C0.269204 4.02369 0.269204 4.34027 0.464466 4.53553C0.659728 4.7308 0.976311 4.7308 1.17157 4.53553L4 1.70711L6.82843 4.53553C7.02369 4.7308 7.34027 4.7308 7.53553 4.53553C7.7308 4.34027 7.7308 4.02369 7.53553 3.82843L4.35355 0.646446ZM4.5 13L4.5 1H3.5L3.5 13H4.5Z",
  fill: "#636363"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.64645 21.3536C3.84171 21.5488 4.15829 21.5488 4.35355 21.3536L7.53553 18.1716C7.7308 17.9763 7.7308 17.6597 7.53553 17.4645C7.34027 17.2692 7.02369 17.2692 6.82843 17.4645L4 20.2929L1.17157 17.4645C0.976311 17.2692 0.659728 17.2692 0.464466 17.4645C0.269204 17.6597 0.269204 17.9763 0.464466 18.1716L3.64645 21.3536ZM3.5 10L3.5 21H4.5L4.5 10H3.5Z",
  fill: "#636363"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23 21C28.5228 21 33 16.5228 33 11C33 5.47715 28.5228 1 23 1C17.4772 1 13 5.47715 13 11C13 16.5228 17.4772 21 23 21Z",
  fill: "#636363"
});

function SvgCapAraligi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapAraligi);
export default __webpack_public_path__ + "static/media/cap_araligi.5c47c8c0.svg";
export { ForwardRef as ReactComponent };